'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePicker = require('./DatePicker');

var _DatePickerDialog = require('./DatePickerDialog');

var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);

var _Calendar = require('./Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _Dialog = require('../../../Dialog/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _IconButton = require('../../../buttons/IconButton/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Input = require('../../Input/Input');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

//eslint-disable-line
var Calendar = (0, _Calendar2.default)(_IconButton2.default); // eslint-disable-line

var DatePickerDialog = (0, _DatePickerDialog2.default)(_Dialog2.default, Calendar);
var DatePicker = (0, _DatePicker.datePickerFactory)(_Input.BasicInput, DatePickerDialog);

exports.default = DatePicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/DatePicker/Toolbox/index.js
// module id = 445
// module chunks = 0